import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import 'theme/index.css';
import App from './App';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container not found');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>
);
